"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutFlowEnteredDTO = exports.SelectedTransactionFeeChangedDTO = exports.SelectedCurrencyChangedDTO = exports.CurrencySelectorOpenedDTO = exports.PurchaseFulfillDTO = exports.PurchaseCompleteDTO = exports.PurchaseAttemptDTO = void 0;
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const types_1 = require("../types");
const dto_factory_1 = require("../types/dto-factory");
let PurchaseAttemptDTO = class PurchaseAttemptDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PurchaseAttemptDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "transactionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unitPrice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transactionFee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currencyUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique transaction identifier'),
    (0, decorators_1.Warning)('Use only if known prior'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value'),
    (0, decorators_1.Warning)('Typically quantity * unitPrice'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Purchase currency type'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique product id'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity purchased'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Price Ea.'),
    __metadata("design:type", Number)
], PurchaseAttemptDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Transaction fee'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "transactionFee", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total USD value of this transaction'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "totalUSDValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency value in USD at time of event'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseAttemptDTO.prototype, "currencyUSDValue", void 0);
PurchaseAttemptDTO = __decorate([
    (0, decorators_1.Describe)('A purchase was initiated which is asyncronous in nature')
], PurchaseAttemptDTO);
exports.PurchaseAttemptDTO = PurchaseAttemptDTO;
let PurchaseCompleteDTO = class PurchaseCompleteDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PurchaseCompleteDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "transactionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unitPrice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transactionFee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currencyUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique lookup id for transaction, e.g. Payment Hash'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total value'),
    (0, decorators_1.Warning)('Typically quantity * unitPrice'),
    __metadata("design:type", Number)
], PurchaseCompleteDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Purchase currency type'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Unique product id'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Quantity purchased'),
    __metadata("design:type", Number)
], PurchaseCompleteDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Price Ea.'),
    __metadata("design:type", Number)
], PurchaseCompleteDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Transaction fee'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "transactionFee", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total USD value of this transaction'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "totalUSDValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency value in USD at time of event'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseCompleteDTO.prototype, "currencyUSDValue", void 0);
PurchaseCompleteDTO = __decorate([
    (0, decorators_1.Describe)('A purchase has completed validation and is awaiting fulfillment')
], PurchaseCompleteDTO);
exports.PurchaseCompleteDTO = PurchaseCompleteDTO;
let PurchaseFulfillDTO = class PurchaseFulfillDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.PurchaseFulfillDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "transactionId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "total", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "quantity", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unitPrice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "transactionFee", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "totalUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currencyUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique transaction identifier'),
    (0, decorators_1.Warning)('Should match PurchaseAttemptDTO event'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "transactionId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Total value'),
    (0, decorators_1.Warning)('Typically quantity * unitPrice'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "total", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Purchase currency type'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unique product id'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Quantity purchased'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "quantity", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Price Ea.'),
    __metadata("design:type", Number)
], PurchaseFulfillDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Transaction fee'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "transactionFee", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Total USD value of this transaction'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "totalUSDValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Currency value in USD at time of event'),
    (0, decorators_1.Warning)('Only set if concrete'),
    __metadata("design:type", String)
], PurchaseFulfillDTO.prototype, "currencyUSDValue", void 0);
PurchaseFulfillDTO = __decorate([
    (0, decorators_1.Describe)('A purchase was fulfilled completely'),
    (0, decorators_1.Warning)('TransactionID should match purchase attempt, if applicable')
], PurchaseFulfillDTO);
exports.PurchaseFulfillDTO = PurchaseFulfillDTO;
let CurrencySelectorOpenedDTO = class CurrencySelectorOpenedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.CurrencySelectorOpenedDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "selectedCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currencyOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The currently selected currency'),
    __metadata("design:type", String)
], CurrencySelectorOpenedDTO.prototype, "selectedCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)({ each: true }),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('An array of names of currencies that are selectable in the selector.'),
    __metadata("design:type", Array)
], CurrencySelectorOpenedDTO.prototype, "currencyOptions", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("If the selector is being opened as part of the purchase flow for a specific product, specify that product's ID."),
    __metadata("design:type", String)
], CurrencySelectorOpenedDTO.prototype, "productId", void 0);
CurrencySelectorOpenedDTO = __decorate([
    (0, decorators_1.Describe)('The user opened a currency selector control, signaling possible intent to use a non-default currency.')
], CurrencySelectorOpenedDTO);
exports.CurrencySelectorOpenedDTO = CurrencySelectorOpenedDTO;
let SelectedCurrencyChangedDTO = class SelectedCurrencyChangedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SelectedCurrencyChangedDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "previousSelectedCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newSelectedCurrency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The previously selected currency'),
    __metadata("design:type", String)
], SelectedCurrencyChangedDTO.prototype, "previousSelectedCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The newly selected currency'),
    __metadata("design:type", String)
], SelectedCurrencyChangedDTO.prototype, "newSelectedCurrency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("If the currency selection was made as part of the purchase flow for a specific product, specify that product's ID."),
    __metadata("design:type", String)
], SelectedCurrencyChangedDTO.prototype, "productId", void 0);
SelectedCurrencyChangedDTO = __decorate([
    (0, decorators_1.Describe)('The user changed their selected currency. This event should typically be preceded by a CheckoutFlowEntered event.')
], SelectedCurrencyChangedDTO);
exports.SelectedCurrencyChangedDTO = SelectedCurrencyChangedDTO;
let SelectedTransactionFeeChangedDTO = class SelectedTransactionFeeChangedDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.SelectedTransactionFeeChangedDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "previousValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "newValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The previously selected transaction fee'),
    __metadata("design:type", Number)
], SelectedTransactionFeeChangedDTO.prototype, "previousValue", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The newly selected transaction fee'),
    __metadata("design:type", Number)
], SelectedTransactionFeeChangedDTO.prototype, "newValue", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)("If the transaction fee change was made as part of the purchase flow for a specific product, specify that product's ID."),
    __metadata("design:type", String)
], SelectedTransactionFeeChangedDTO.prototype, "productId", void 0);
SelectedTransactionFeeChangedDTO = __decorate([
    (0, decorators_1.Describe)('The user changed their selected transaction fee.')
], SelectedTransactionFeeChangedDTO);
exports.SelectedTransactionFeeChangedDTO = SelectedTransactionFeeChangedDTO;
let CheckoutFlowEnteredDTO = class CheckoutFlowEnteredDTO extends (0, dto_factory_1.DTOFactory)(types_1.GalEvents.CheckoutFlowEnteredDTO) {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "currency", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "productId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "unitPrice", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "currencyUSDValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
};
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The purchase currency name at the time the checkout flow was entered'),
    (0, decorators_1.Warning)('Note that the user may have an opportunity to change to a different currency after entering this flow, so this is not necessarily the currency that will ultimately be used for purchase.'),
    __metadata("design:type", String)
], CheckoutFlowEnteredDTO.prototype, "currency", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('The ID of the product being purchased'),
    __metadata("design:type", String)
], CheckoutFlowEnteredDTO.prototype, "productId", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, decorators_1.Describe)('Unit price of the product in terms of the currency'),
    __metadata("design:type", Number)
], CheckoutFlowEnteredDTO.prototype, "unitPrice", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Value of the currency in USD if known'),
    (0, decorators_1.Warning)('Only set if known'),
    __metadata("design:type", String)
], CheckoutFlowEnteredDTO.prototype, "currencyUSDValue", void 0);
CheckoutFlowEnteredDTO = __decorate([
    (0, decorators_1.Describe)('The user entered into the checkout process for a product. This implies that the user took an action signaling clear intent to make a purchase (such as clicking "Buy" button)')
], CheckoutFlowEnteredDTO);
exports.CheckoutFlowEnteredDTO = CheckoutFlowEnteredDTO;
